<template>
  <div>
    <base-table :data="$props.channels"
                :columns="tableColumns"
                class="channel-table">
      <template #position="tableData">
        {{ getChannelPosition(tableData.rowData) }}
      </template>
      <template #genre="tableData">
        {{ getGenre(tableData.rowData) }}
      </template>
      <template #package="tableData">
        <template v-for="(pack, index) in getTVPackages(tableData.rowData).packages">
        <span :key="'package'+index" class="tariff-link">
          <a :href="getChannelLink(pack)">{{ pack }}</a><template
          v-if="index < getTVPackages(tableData.rowData).packages.length - 1">,&nbsp; </template>
        </span>
        </template>
        <div v-if="getTVPackages(tableData.rowData).addons.length">
      <span v-for="(packs, index) in getTVPackages(tableData.rowData).addons" :key="'addon'+index">
        {{ packs }}<template v-if="index < getTVPackages(tableData.rowData).addons.length - 1">, </template>
      </span>
        </div>
      </template>
      <template #image="tableData">
        <img :src="getImage(tableData.rowData)" :alt="tableData.rowData.name" class="channel-image">
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from '../base/table/base-table'
import { getClosestPackageNameLink } from '../../utils/tvChannelsPackagesMapping'

export default {
  name: 'channels-list',
  components: { BaseTable },
  props: {
    channels: {
      type: Array,
      default: () => []
    },
    packageLinks: String
  },
  data () {
    return {
      tableColumns: Object.freeze([
        {
          key: 'name',
          label: 'Ime kanala',
          width: '20%'
        },
        {
          key: 'position',
          label: 'Pozicija',
          width: '20%',
          slot: 'position'
        },
        {
          key: 'genre',
          label: 'Žanr',
          width: '20%',
          slot: 'genre'
        },
        {
          key: 'package',
          label: 'TV paket',
          width: '20%',
          slot: 'package'
        },
        {
          key: 'image',
          label: ' ',
          width: '20%',
          slot: 'image',
          colClass: 'center-content'
        }
      ])
    }
  },
  computed: {
    parsedPackageLinks () {
      const linksObj = {}
      const linksPerLine = this.$props.packageLinks.split(',')

      linksPerLine.forEach(link => {
        const splitLink = link.split('=')
        if (splitLink.length === 2) {
          linksObj[splitLink[0]] = splitLink[1]
        }
      })
      return linksObj
    }
  },
  methods: {
    getChannelPosition (rowData) {
      const position = rowData.classifications?.[0]?.features?.[0]?.featureValues?.[0]?.value
      return position.padStart(3, '0')
    },
    getGenre (rowData) {
      return rowData.categories.map(cat => cat.name).join(', ')
    },
    getTVPackages (rowData) {
      const channelPackages = rowData.classifications[0].features[1].featureValues
      const allPackages = {
        packages: [],
        addons: []
      }
      channelPackages.forEach(p => {
        if (p.category) {
          allPackages.packages.push(p.value)
        } else {
          allPackages.addons.push(p.value)
        }
      })
      return allPackages
    },
    getImage (rowData) {
      return rowData.images?.[0]?.url
    },
    getChannelLink (packageName = '') {
      if (!packageName) return '#'
      if (this.parsedPackageLinks[packageName]) {
        return this.parsedPackageLinks[packageName]
      } else {
        return getClosestPackageNameLink(this.parsedPackageLinks, packageName)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.channel-table {
  padding: 0;
  background-color: transparent;

  /deep/ .table-head, /deep/ .table-row {
    border-radius: 5px;
    margin-bottom: 0.4rem;
    background-color: $white;
    padding: 0 2.4rem;
    width: 100%;

    @media (map_get($breakpoints, md)) {
      align-items: center;
    }

    .head-cell {
      font-size: 1.4rem;
      font-weight: normal;
      color: $dark-grey;
    }

    .table-cell {
      color: $text;
      padding: 1.2rem 1.2rem 1.2rem 0;
      @media (map_get($breakpoints, md)) {
        max-width: 20%;
      }
    }

    p {
      margin-bottom: 0;
    }
  }

  .tariff-link {
    font-weight: 600;
    display: inline-block;
    white-space: nowrap;
  }

  .channel-image {
    width: auto;
    max-height: 64px;
  }

  /deep/ .center-content {
    text-align: center;
  }
}
</style>
